import { useEffect, useState } from 'react';
import { format, parse, isValid } from 'date-fns';
import createAxiosInstance from '../../../services/axiosConfig';

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/feriados');

interface Feriado {
  data: string;
}

export const useCalculaDiaUtil = (
  dtSimulacao: string,
  diaCorte: number,
  diaVencimento: number,
  faixaCarencia: number,
  ajustaDU: string,
  empregadorId?: number | null // ID do empregador, pode ser nulo ou indefinido
) => {
  const [feriados, setFeriados] = useState<Date[]>([]);
  const [dataFinal, setDataFinal] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!dtSimulacao || ajustaDU !== 'sim') {
      setFeriados([]);
      return;
    }

    const parsedDate = parse(dtSimulacao, 'dd/MM/yyyy', new Date());
    if (!isValid(parsedDate)) {
      console.warn('Data inválida para buscar feriados:', dtSimulacao);
      return;
    }

    const ano = parsedDate.getFullYear();
    
    let url = `/diasUteis?ano=${ano}`;
    
    if (empregadorId) {
      url += `&empregadorId=${empregadorId}`;
    }

    setIsLoading(true);

    axiosInstance
      .get<Feriado[]>(url)
      .then((res) => {
        const datas = res.data.map((f) => new Date(f.data));
        setFeriados(datas);
      })
      .catch((err) => console.error('Erro ao buscar feriados consolidados:', err))
      .finally(() => {
        setIsLoading(false);
      });

  // Se o ID mudar, a busca é refeita.
  }, [dtSimulacao, ajustaDU, empregadorId]); 

  useEffect(() => {
    if (
      !dtSimulacao ||
      isNaN(diaCorte) ||
      isNaN(diaVencimento) ||
      faixaCarencia === undefined ||
      faixaCarencia === null
    ) {
      return;
    }

    const parsedDate = parse(dtSimulacao, 'dd/MM/yyyy', new Date());
    if (!isValid(parsedDate)) {
      return;
    }

    const mesesBase = (parsedDate.getDate() > diaCorte ? 2 : 1) + faixaCarencia;

    const isFeriadoOuFinalDeSemana = (data: Date) => {
      const dia = data.getDay(); // 0 = Domingo, 6 = Sábado
      const dataFormatada = format(data, 'yyyy-MM-dd');
      return (
        dia === 0 ||
        dia === 6 ||
        feriados.some((f) => format(f, 'yyyy-MM-dd') === dataFormatada)
      );
    };

    const somarDiasUteis = (dataInicial: Date, diasUteisNecessarios: number) => {
      let data = new Date(dataInicial);
      let adicionados = 0;
      while (adicionados < diasUteisNecessarios) {
        data.setDate(data.getDate() + 1);
        if (!isFeriadoOuFinalDeSemana(data)) {
          adicionados++;
        }
      }
      return data;
    };

    let dataCalculada;
    if (ajustaDU === 'sim') {
      const diasUteisEstimados = mesesBase * 30; // Esta estimativa pode ser ajustada
      dataCalculada = somarDiasUteis(parsedDate, diasUteisEstimados);
    } else {
      dataCalculada = new Date(parsedDate);
      dataCalculada.setMonth(dataCalculada.getMonth() + mesesBase);
    }

    dataCalculada.setDate(Number(diaVencimento));
    setDataFinal(format(dataCalculada, 'dd/MM/yyyy'));

  }, [dtSimulacao, diaCorte, diaVencimento, faixaCarencia, ajustaDU, feriados]);

  return {dataFinal, isLoading};
};